import { AlmeConfig } from "../models/AlmeConfig";
import { AlmeApiUtils } from "../api/AlmeApiUtils";
import { AlmeAppState } from "../components/AlmeApp/AlmeAppState";
import defaultLogger from "../Logger";
import useRecursiveTimeout from "./useRecursiveTimeout";

export function usePollForNotifications(almeConfig: AlmeConfig, isInitialized: React.MutableRefObject<boolean>, almeState: AlmeAppState, apiUtils: React.MutableRefObject<AlmeApiUtils>): void {
    useRecursiveTimeout(async () => {
        const shouldPoll = almeConfig.notificationApi.pollForNotifications && isInitialized.current && almeState.isOpen;
        if (shouldPoll) {
            try {
                await apiUtils.current.getNotifications();
            } catch (ex) {
                defaultLogger.error('getNotifications error: ', ex);
            }
        }
    }, almeConfig.notificationApi.notificationInterval);
}